import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Avatar, Divider, Typography } from '@mui/material';

import { DrawerContent } from 'components/common/drawer/DrawerContent';
import { EntityFileDetails } from 'components/shared/EntityFileDetails';

import { useProfileDrawers } from 'hooks/useProfileDrawers';
import { current } from '@reduxjs/toolkit';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

export const ProfileDetails = () => {
  const dispatch = useDispatch();
  const { openDrawerEditProfile } = useProfileDrawers();
  const currentUser = useSelector((state) => state.auth.currentUser);

  useEffect(() => {
    if (!currentUser || Object.keys(currentUser).length === 0) {
      dispatch(current());
    }
  }, [currentUser, dispatch]);

  return (
    <DrawerContent>
      <DrawerContent.Header title="Profile" />
      <DrawerContent.Wrapper>
        <DrawerContent.Content>
          <EntityFileDetails>
            <EntityFileDetails.FileType
              fileIcon={
                <Avatar sx={{ width: 90, height: 90, fontSize: 35 }}>
                  {currentUser?.name
                    ?.split(' ')
                    .slice(0, 2)
                    .map((word) => word.charAt(0).toUpperCase())
                    .join('')}
                </Avatar>
              }
            />
            <EntityFileDetails.Details title={currentUser?.name || ''}>
              {currentUser?.email && (
                <EntityFileDetails.DetailsItem
                  title="Email"
                  subtitle={currentUser.email}
                />
              )}
              {currentUser?.contact?.phone && (
                <EntityFileDetails.DetailsItem
                  title="Mobile Number"
                  subtitle={currentUser.contact.phone}
                />
              )}
              {currentUser?.contact?.address && (
                <EntityFileDetails.DetailsItem
                  title="Address"
                  subtitle={`${currentUser.contact.address?.address}, ${currentUser.contact.address?.suburb}, ${currentUser.contact.address?.state} ${currentUser.contact.address?.postcode}`}
                />
              )}
              {currentUser?.organisations?.length > 0 && (
                <EntityFileDetails.DetailsItem
                  title="Organisation"
                  subtitle={currentUser.organisations
                    .slice(0, 5)
                    .map((org) => org.name)
                    .join(', ')}
                  showMoreText={
                    currentUser?.organisations && currentUser.organisations.length > 5
                      ? `and ${currentUser.organisations.length - 5} more.`
                      : null
                  }
                  tooltipTitle={
                    <Typography variant="caption">
                      {currentUser.organisations
                        .slice(5)
                        .map((org) => org.name)
                        .join(', ')}
                    </Typography>
                  }
                />
              )}
            </EntityFileDetails.Details>
            <Divider />
            <EntityFileDetails.ActionButton
              title="Edit Profile"
              icon={<EditOutlinedIcon sx={{ fontSize: '22px' }} />}
              action={openDrawerEditProfile}
            />
          </EntityFileDetails>
        </DrawerContent.Content>
      </DrawerContent.Wrapper>
    </DrawerContent>
  );
};
